import { render, staticRenderFns } from "./ContinueWithFolio.vue?vue&type=template&id=e754128c&"
import script from "./ContinueWithFolio.vue?vue&type=script&lang=js&"
export * from "./ContinueWithFolio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports